// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2TFDs","log":"ModalInventoryLogs_log__1L-xm","date":"ModalInventoryLogs_date__2Jz-r","userName":"ModalInventoryLogs_userName__3quwy"};